export enum FormSpecialSubmissionErrorWidgetAttributes {
  TRIGGERING_ERROR_MESSAGE = 'triggeringErrorMessage',
  RESULTING_SPECIAL_ERROR = 'resultingSpecialError',
}
